import { constant, get } from 'lodash/fp';
import backfillAtc from '../../api/oldMandi/backfillAtc';

export default cartingOptions =>
  backfillAtc(get('job.id', cartingOptions), { bookJobSucceeded: true, addToCartSucceeded: true })
    .then(constant(cartingOptions));
